//******************************************************************************
// import
// import * as TurfHelpers from "@turf/helpers";
// import nearestPointOnLine from "@turf/nearest-point-on-line";
import { MeasureUtils } from "./MeasureUtils";
import { getContrastColor } from "../optimizeColor/getContrastColor";
import htmlPoint from "./popup.point.html";
import htmlWaypoints from "./popup.waypoints.html";
import htmlTriangle from "./popup.triangle.html";
import htmlSegments from "./popup.segments.html";
import "./popup.css";

//******************************************************************************
// ポップアップのhtml文字列をオブジェクトに格納しておく
const popups = {};
popups.point = htmlPoint;
popups.waypoints = htmlWaypoints;
popups.triangle = htmlTriangle;
popups.segments = htmlSegments;

//******************************************************************************
// export class
export class TriggerMeasure {
	//**************************************************************************
	// メンバ変数
	// maplibreのmap（projectメソッドを使うために必要）
	map;
	// ポップアップ要素を格納する親要素
	parent;
	// ポップアップのhtml文字列をノードに変換して格納
	popups;
	// 球からのオフセット位置
	offset;
	// 計算ユーティリティのインスタンス
	utility;
	// ポップアップノード
	node;

	//**************************************************************************
	/**
	 * コンストラクタ
	 * @param {HTMLElemest} parent
	*/
	constructor(parent) {
		//----------------------------------------------------------------------
		// メンバ変数を用意
		this.parent = parent;
		this.popups = {};
		this.offset = [10, 10];
		this.utility = new MeasureUtils();
		//----------------------------------------------------------------------
		// ポップアップhtml文字列をDOMノードに変換、閉じるボタンの有効化
		Object.keys(popups).forEach((key) => {
			const element = this.popups[key] = new DOMParser().parseFromString(
				popups[key], "text/html"
			).querySelector("#popup").cloneNode(true);
			element.querySelector("span.close").addEventListener("click", (event) => {
				this.dispose();
			});
		});
	}

	//**************************************************************************
	/**
	 * 球クリック処理
	 * @param {Object} picking
	 * @param {string} type
	 * @returns {this}
	*/
	clickSphere(picking, type) {
		//----------------------------------------------------------------------
		// ノードの破棄
		this.dispose();
		//----------------------------------------------------------------------
		// 使用するノードを決める
		const node = this.node = this.popups[type];
		//----------------------------------------------------------------------
		// ノードがHTML要素の場合のみ処理（計測クリア時はnodeがundefinedになる）
		if (this.node instanceof HTMLElement) {
			// 値をすべて空にする
			node.querySelectorAll("dd").forEach((element) => {
				element.textContent = "";
				element.style.backgroundColor = "#ffffff";
			});
			// ポップアップ共通処理
			// 球の属性を取得
			const vertex = picking.object;
			// ポイントに関する情報はすべてのtypeで実行
			// 位置の処理
			["lng", "lat", "elev"].forEach((value, index) => {
				// 値の格納先を決めて格納
				const element = node.querySelector(`.${value}`);
				element.textContent = vertex.coordinates[index].toFixed(6);
				// ノードに経度、緯度、標高の生の値を保持させる
				node.dataset[value] = vertex.coordinates[index];
			});
			// 色の処理
			// 値の格納先を決めて格納
			const element = node.querySelector(".color");
			element.textContent = `rgb(${vertex.color.slice(0, 3).toString()})`;
			// 背景色を設定する
			element.style.backgroundColor = element.textContent;
			// 背景色から文字色を決める
			const fontColor = getContrastColor(...vertex.color);
			// 文字色を設定する
			element.style.color = fontColor;
			// 登録済みのすべての球を取得する
			const points = picking.layer.props.data;
			// 計測種別で分岐
			switch (type) {
				// point指定の場合は追加の処理なし
				case "point":
					break;
				// waypoints指定の場合
				case "waypoints":
					// 球が2つ以上ない場合は追加の計算をしない
					if (points.length > 1) {
						// 最初の球でない場合のみ処理
						if (picking.index > 0) {
							// クリックされた球の直前に登録された球を探す
							const previous = points[picking.index - 1];
							// 直前の球とクリックされた級の距離を決める
							const distance = this.utility.getDistance(
								previous.coordinates,
								picking.object.coordinates
							);
							// ノードに値を格納する
							node.querySelector(".distance").textContent = distance.toFixed(6);
							// 直前の球からクリックされた球に対する方位を決める
							const direction = this.utility.getDirection(
								previous.coordinates,
								picking.object.coordinates
							);
							// ノードに値を格納する
							node.querySelector(".direction").textContent = direction.toFixed(6);
							// 傾斜角
							const incline = this.utility.getInclination(
								previous.coordinates,
								picking.object.coordinates
							);
							// ノードに値を格納する
							node.querySelector(".incline").textContent = incline.toFixed(6);
						} else {
							// 最初の球の場合は空にする
							node.querySelector(".distance").textContent = "";
							node.querySelector(".incline").textContent = "";
							node.querySelector(".direction").textContent = "";
						}
						// すべての線分の距離の合計を調べる
						const total = points.reduce((acc, cur, index) => {
							return acc + (
								typeof points[index + 1] === "undefined"
									? 0
									: this.utility.getDistance(
										cur.coordinates,
										points[index + 1].coordinates
									)
							);
						}, 0);
						// ノードに値を格納する
						node.querySelector(".total").textContent = total.toFixed(6);
					}
					break;
				// triangle指定の場合
				case "triangle":
					// 球が3つない場合は角度計算はしない
					if (points.length === 3) {
						// クリックされた球の座標を決める
						const origin = picking.object.coordinates;
						// 両翼の座標を決める
						const sides = points.filter((value, index) => {
							return index !== picking.index;
						}).map((value) => {
							return value.coordinates;
						});
						// 角度を決める
						const angle = this.utility.getAngle(origin, sides);
						// ノードに値を格納する
						node.querySelector(".angle").textContent = angle.toFixed(6);
					}
					break;
				default:
				//
			}
			// 親要素にポップアップを登録して位置を決める
			this.parent.appendChild(node);
			// this.update();
		}
		//----------------------------------------------------------------------
		// 参照を返す
		return this;
	}

	//**************************************************************************
	/**
	 * 線分クリック処理
	 * @param {Object} picking
	 * @param {Event} event
	 * @returns {this}
	*/
	clickSegments(picking, event) {
		//----------------------------------------------------------------------
		// ノードの破棄
		this.dispose();
		//----------------------------------------------------------------------
		// 使用するノードを決める
		const node = this.node = this.popups.segments;
		//----------------------------------------------------------------------
		// ノードがHTML要素の場合のみ処理（計測クリア時はnodeがundefinedになる）
		if (this.node instanceof HTMLElement) {
			// 値をすべて空にする
			node.querySelectorAll("dd").forEach((element) => {
				element.textContent = "";
			});
			// 2点を取得
			const points = picking.object.path;
			// パスのクリック位置を特定（pickingから直接取得できないので画面位置から決定）
			const clicked = (() => {
				// 画面上の各位置を調べる
				const clicked = [event.srcEvent.lngLat.lng, event.srcEvent.lngLat.lat];
				const use = Math.abs(points[0][0] - points[1][0]) > Math.abs(points[0][1] - points[1][1]) ? 0 : 1;
				const total = points[0][use] - points[1][use];
				const target = points[0][use] - clicked[use];
				const elevation = (points[0][use] - points[1][use]) * target / total + points[1][2];
				return [...clicked, elevation];
			})();

			["lng", "lat", "elev"].forEach((value, index) => {
				// ノードに経度、緯度、標高の生の値を保持させる
				node.dataset[value] = clicked[index];
			});
			// 距離を決める
			const distance = this.utility.getDistance(...points);
			// ノードに値を格納する
			node.querySelector(".distance").textContent = distance.toFixed(6);
			// 方位を決める
			const direction = this.utility.getDirection(...points);
			// ノードに値を格納する
			node.querySelector(".direction").textContent = direction.toFixed(6);
			// 傾斜角を決める
			const incline = this.utility.getInclination(...points);
			// ノードに値を格納する
			node.querySelector(".incline").textContent = incline.toFixed(6);
			// 親要素にポップアップを登録して位置を決める
			this.parent.appendChild(node);
			// this.update();
		}
		//----------------------------------------------------------------------
		// 参照を返す
		return this;
	}

	//**************************************************************************
	/**
	 * ポップアップ位置更新（クリックしたら必ずupdateを呼び出す）
	 * @param {Object} map
	 * @returns {this}
	*/
	update(map) {
		//----------------------------------------------------------------------
		// ノード生成済みかつ親要素に登録済みの場合のみ処理
		if (this.node instanceof HTMLElement && this.node.parentNode !== null) {
			// ノードに登録された経度、緯度、標高のデータ値から配列を作る
			const coordinates = ["lng", "lat", "elev"].map((value) => {
				return Number(this.node.dataset[value]);
			});
			// スクリーン座標に変換する
			const { x, y } = map.project(coordinates);
			// ポップアップ位置を決める
			this.node.style.left = `${x + this.offset[0]}px`;
			this.node.style.top = `${y + this.offset[1]}px`;
		}
		//----------------------------------------------------------------------
		// 参照を返す
		return this;
	}

	//**************************************************************************
	/**
	 * ポップアップ破棄
	 * @returns {this}
	*/
	dispose() {
		//----------------------------------------------------------------------
		// ノード生成済みかつ親要素に登録済みの場合に親要素から取り除く
		if (this.node instanceof HTMLElement && this.node.parentNode !== null) {
			this.node.remove();
		}
		//----------------------------------------------------------------------
		// 参照を返す
		return this;
	}
}
